export const AMENDMENT_REASONS = {
  Error: 'Error',
  MissedIncomeForm: 'MissedIncomeForm',
  MissedDeduction: 'MissedDeduction',
  Other: 'Other',
};
